import(/* webpackMode: "eager" */ "/choonchoonchoonchoonchoonchoonchoonchoonchoonchoon/app/global-error.tsx");
